import { Inject, Pipe, PipeTransform } from '@angular/core';
import { moment } from '@app/lib/moment';
import { Session } from '../services/session';

const ONE_THOUSAND_ONLY: number = 1000;
const ONE_THOUSAND_DOT_ZERO: number = 1000.0;

@Pipe({ name: 'epochDateTime' })
export class EpochDateTimeConverter implements PipeTransform {
  constructor(@Inject(Session) private session: Session) { }

  public transform(toConvert: any, dateTimeFormat: string = 'MM/DD, hh:mm A z', timezone?: string) {
    if (!toConvert) return '--';
    if (!this.isInvalidTimeZone(timezone)) timezone = this.session.getUserTimeZone();
    if (Number.isInteger(toConvert)) {
      return moment(new Date(toConvert * ONE_THOUSAND_ONLY)).mapTz(timezone).format(dateTimeFormat);
    }
    const date = moment(toConvert);
    if (date.isValid()) return Math.floor(new Date(toConvert).getTime()/ONE_THOUSAND_DOT_ZERO);
  }

  private isInvalidTimeZone(timezone: string) {
    try {
      Intl.DateTimeFormat(undefined, {timeZone: timezone});
      return false;
    }
    catch (ex) {
      return true;
    }
  }
}
